import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import ReactDatePicker from 'react-datepicker';
import { Calendar, Clock } from '@phosphor-icons/react';
import { addDays } from 'date-fns';
import 'react-datepicker/dist/react-datepicker.css';
import './style';

const CustomInput = forwardRef((props, ref) => {
  const {
    label,
    value,
    onClick,
    type,
  } = props;

  return (
    <div
      className="datepicker-dropdown px-6 py-4 flex items-center justify-between"
      ref={ref}
      onClick={onClick}
    >
      <div className="flex flex-col gap-0.5">
        <div className="text-12 grey-70">{label}</div>
        <div className="label-16 black">{value}</div>
      </div>
      {type === 'date' ? <Calendar size={28}
        className="calendar-icon" /> : <Clock size={28}
        className="calendar-icon" />}
    </div>
  );
});

const DatePicker = (props) => {
  const {
    label,
    defaultDate,
    onChange,
    type,
    selected,
    disablePreviousDates,
    ...attr
  } = props;

  return (
    <div className="date-picker-wrapper flex items-center">
      <ReactDatePicker
        calendarClassName="date-picker"
        dateFormat="EEE, MMM dd"
        popperPlacement="bottom-center"
        selected={selected}
        onChange={onChange}
        customInput={<CustomInput label={label}
          selectedDate={selected}
          type={type} />}
        {...(disablePreviousDates) && ({ minDate: addDays(new Date(), 1) })}
        {...attr}
      />
    </div>
  );
};

DatePicker.propTypes = {
  label: PropTypes.string,
  defaultDate: PropTypes.string,
  onChange: PropTypes.func,
  type: PropTypes.oneOf(['date', 'time']),
  selected: PropTypes.string,
  disablePreviousDates: PropTypes.bool,
};

DatePicker.defaultProps = {
  label: 'Start Date',
  defaultDate: new Date(),
  onChange: () => null,
  type: 'date',
  selected: new Date(),
  disablePreviousDates: false,
};

export default DatePicker;
